import { EBuyPackageStatus, TAppState } from '../../types';

export const selectBuyPackageModalStatus = (state: TAppState): EBuyPackageStatus => {
  return state.buyPackage.status;
};
